import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { isValidNameWithSpace, renderTextArea, renderTextField, renderCheckBox, isInteger } from '../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import { getMasterClinicalRoomById, saveMasterClinicalRoom } from '../actions/MasterClinicalRoomActions';
import validate from '../validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../AppConfig/actions';
import { MODULE } from '../constants/ApiConstants';
import { displayCustomError } from '../../../../../actions/utilAction';
import SmallLoader from '../../../../../img/small-loader.gif';

class MasterClinicalRoomsModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      masterClinicalRoomId: props.masterClinicalRoomId,
      IsBillable: null,
    };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };


  componentWillReceiveProps() {
    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }
  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': (this.props.initialValues && this.props.initialValues.id) ? this.props.initialValues.id : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };
  componentWillMount() {
    if (this.props.masterClinicalRoomId) {
      this.props.getMasterClinicalRoomById(this.props.masterClinicalRoomId);
    }
  }
  onSubmitHandler(formData) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formData.id = this.state.masterClinicalRoomId;
    formData.roomName = formData.roomName.trim();
    formData.description = formData.description ? formData.description.trim() : '';
    formData.isActive = formData.isActive || false;
    formData.roomCapacity = formData.roomCapacity || null;
    this.props.clearFieldErrorArray();
    this.props.saveMasterClinicalRoom(formData);
    this.setState({ open: false });
    this.props.closeDialog();
  }
  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog className="custom_modal"
        title={this.props.masterClinicalRoomId ? 'Edit Therapy Room' : 'Add Therapy Room'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-12  require">
                  <Field
                    autoFocus={true}
                    name="roomName"
                    type="text"
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Room name')}
                    customError={displayCustomError('ROOMNAME', this.props.fieldError)}
                    maxLength="100"
                    label="Room Name"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
                <div className="col-sm-12 col-md-12">
                  <Field
                    name="description"
                    type="text"
                    maxLength="1000"
                    label="Description"
                    component={renderTextArea} />
                  <small className="blackfont font12">{this.props.description ? 1000 - this.props.description.length : 1000} Characters Remaining </small>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">                 
                  <Field
                    name="roomCapacity"
                    type="text"
                    maxLength="3"
                    label="Room Capacity"
                    normalize={isInteger}                    
                    component={renderTextField} />
                </div>
                <div className="col-sm-6">
                  <Field className="mt20 mb0 custm_check"
                    name="isActive"
                    label="Is Active"
                    component={renderCheckBox}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 custm_appointmenttype">
                  <span>Leave this blank if the room if you do not want to set a capacity.</span>
                </div>                  
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}
const selector = formValueSelector('MasterClinicalRoomModalForm');
function mapStateToProps(state, ownProps) {
  let initialValueData = null;
  if (ownProps.masterClinicalRoomId && state.masterClinicalRoom.getMasterClinicalRoomById && state.masterClinicalRoom.getMasterClinicalRoomById.data) {
    initialValueData = state.masterClinicalRoom.getMasterClinicalRoomById.data;
  }
  return {
    description: selector(state, 'description'),
    loading: state.masterClinicalRoom.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
  };
}

MasterClinicalRoomsModal = reduxForm({
  form: 'MasterClinicalRoomsModalForm',
  validate,
  enableReinitialize: true,
})(MasterClinicalRoomsModal);

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveMasterClinicalRoom, getMasterClinicalRoomById })(MasterClinicalRoomsModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterClinicalRoom/components/MasterClinicalRooms_Modal.js